import { create } from "zustand";

/** Interface */
type ChatState = "open" | "collapsed" | "hidden";

interface IChatStore {
	state: ChatState;
	setState: (state: ChatState) => void;
	handleOnToggleCollapsedState: () => void;
	handleOnCollapse: () => void;
	handleOnOpen: () => void;
}

/** Store */
export const useChatStore = create<IChatStore>((set, get) => ({
	/**
	 * This is the current state of the chat popover.
	 * It can be either "open", "collapsed" or "hidden".
	 * @type {ChatState}
	 */
	state: "collapsed",

	/**
	 * This function is used to set the chat popover state.
	 * @param state
	 * @returns
	 */
	setState: (state: ChatState) => set(() => ({ state })),

	/**
	 * This function is used to toggle the chat popover from open to collapsed and vice versa.
	 * @returns
	 */
	handleOnToggleCollapsedState: () =>
		set(() => {
			const currentState = get().state;
			return {
				state: currentState === "open" ? "collapsed" : "open",
			};
		}),

	/**
	 * This function is used to collapse the chat popover.
	 * @returns
	 */
	handleOnCollapse: () => set(() => ({ state: "collapsed" })),

	/**
	 * This function is used to open the chat popover.
	 * @returns
	 */
	handleOnOpen: () => set(() => ({ state: "open" })),
}));
